import { NmeaConfig } from "./NmeaConfig"

export class NmeasConfig {
            
    public rowHidden:Array<NmeaConfig>
    public rowInit:Array<NmeaConfig>
    public rowLazy:Array<NmeaConfig>    

    constructor({rowHidden=[], rowInit=[],rowLazy=[]} = {}) {                
        this.rowHidden = rowHidden.map(r => new NmeaConfig(r))
        this.rowInit = rowInit.map(r => new NmeaConfig(r))
        this.rowLazy = rowLazy.map(r => new NmeaConfig(r))
    }    

    static createNmeasConfig(datas:string,nmeaNames:Array<string> = []) {       
        //on filtre les seamrs et seanav
        const nmeas =  nmeaNames//.filter(n => n.toLowerCase() != 'seamrs' &&  n.toLowerCase() != 'seanav')        
        const config =  (datas && datas.length > 0)? new NmeasConfig(JSON.parse(datas)): new NmeasConfig()         
        
        //On ajoute les configs manquantes
        config.rowHidden.push(
            ...nmeas.filter(n => config.rowHidden.findIndex(c => c.name == n) == -1
                                 &&  config.rowInit.findIndex(c => c.name == n) == -1 
                                 &&  config.rowLazy.findIndex(c => c.name == n) == -1
                             ).map(n => new NmeaConfig({name:n}))
        )
        return config
    }

}
